<template>
    <div>
        <b-sidebar
            :title="atendimentoLocal.id ? atendimentoLocal.id + ' - ' + atendimentoLocal.titulo : 'Novo Atendimento'"
            right shadow v-model="localSidebar" backdrop backdrop-variant="dark" width="650px">
            <b-row>
                <b-col cols="8" v-if="!isDistribuidor && atendimentoLocal.distribuidor">
                    <h6>{{ atendimentoLocal.distribuidor.codigo }} - {{ atendimentoLocal.distribuidor.nome }}</h6>
                </b-col>
                <b-col class="text-right">
                    <h5><b-badge>{{ atendimentoLocal.status }}</b-badge></h5>
                </b-col>
            </b-row>
            <b-card v-if="atendimentoLocal && atendimentoLocal.mensagens && atendimentoLocal.mensagens.length > 0"
                class="ml-1 mr-2 card-msgs" id="card-msg">
                <div ref="chatcontainer" class="mb-3">
                    <div v-for="(mensagem, index) in atendimentoLocal.mensagens" :key="index">
                        <v-atendimento-mensagens :mensagem="mensagem"></v-atendimento-mensagens>
                    </div>
                </div>
            </b-card>
            <template #footer v-if="canSendMensage">
                <b-card class="ml-1 mr-2 mb-1">
                    <b-overlay :show="loading" rounded="sm">
                        <b-row v-if="(!atendimentoLocal || !atendimentoLocal.id)" class="mb-2">
                            <b-col>
                                <b-form-group label="Tipo">
                                    <b-form-select v-model="titulo" :options="tipos"
                                        placeholder="Informe o tipo de atendimento"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col v-if="showAfterStartService">
                                <b-form-group :label="labelChat">
                                    <b-form-textarea v-model="mensagem" :disabled="loading"
                                        @keyup.enter="enviarMensagem()" @input="sendTyping()"
                                        placeholder="Digite uma mensagem ..." rows="2" max-rows="8" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-overlay>
                    <b-row>
                        <b-col
                            v-if="atendimentoLocal && atendimentoLocal.id && ((!isDistribuidor && atendimentoLocal.status !== 'NOVO' && atendimentoLocal.user_id_atendente == user.id) || isDistribuidor)">
                            <b-button variant="secondary" size="sm" @click="triggerFileInput" v-if="!file"
                                :disabled="loading" title="Anexo">
                                <b-icon icon="paperclip"></b-icon>
                            </b-button>
                            <b-form-file ref="fileInput" v-model="file" class="d-none"
                                @input="handleFile"></b-form-file>
                            <p v-if="file"> Anexo: {{ file.name }}
                                <a href="#" @click="removeFile()" v-if="!loading"><i class="fas fa-times"></i></a>
                            </p>
                        </b-col>
                        <b-col class="text-right">
                            <b-button
                                v-if="canFinishService"
                                size="sm" variant="danger" @click="encerrarAtendimento()">
                                <i class="fas fa-lock"></i> Encerrar Atendimento
                            </b-button>
                            <b-button
                                v-if="canStartService"
                                size="sm" variant="warning" @click="iniciarAtendimento()">
                                <i class="fas fa-play-circle"></i> Iniciar Atendimento
                            </b-button>
                            <b-button v-else size="sm" variant="success"
                                @click="enviarMensagem()" :disabled="loading || (mensagem.length < 1 && !file)">
                                <i class="fas fa-paper-plane"></i> Enviar
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
import { initEcho } from '../../echo';

export default {
    props: {
        atendimento: {
            type: Object,
            default: {
                id: null,
                titulo: '',
                mensagens: [],
            }
        },
        tipos: {
            type: Array,
            default: []
        },
        sidebar: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            intervalId: false,
            file: null,
            loading: false,
            localSidebar: this.sidebar,
            titulo: '',
            mensagem: '',
            atendimentoLocal: {
                id: "",
                mensagens: [],
                status: ""
            },
            viewAll: false,
            messages: [],
            channel: null,
            typingTimer: null,
            chatUserTyping: false,
            userResponse: {
                id: null,
                nome: ''
            }
        }
    },
    computed: {
        canSendMensage(){
            return this.atendimentoLocal.user_id_atendente == this.user.id || 
            this.isDistribuidor || 
            (this.atendimentoLocal.status === 'NOVO' && this.isAnalyst);
        },
        showAfterStartService(){
            if(this.canStartService){
                return false
            }

            return true
        },
        validAtendente(){
            return this.atendimentoLocal.user_id_atendente === this.user 
        },
        labelChat() {
            if (this.chatUserTyping) {
                if (this.isDistribuidor) {
                    return 'Atendente está digitando...'
                }
                else {
                    return 'Distribuidor está digitando...'
                }
            }
            return 'Mensagem';
        },
        canFinishService(){
            return this.atendimentoLocal.id && this.atendimentoLocal.status === 'EM ATENDIMENTO' && !this.isDistribuidor && this.atendimentoLocal.user_id_atendente == this.user.id
        },
        canStartService(){
            return this.atendimentoLocal.id && this.atendimentoLocal.status === 'NOVO' && !this.isDistribuidor && this.isAnalyst
        },
        isDistribuidor() {
            return this.$store.getters['user/isDistribuidor'];
        },
        user() {
            return this.$store.getters['user/getUser'];
        },
        isAnalyst(){
            return this.$store.getters['user/isAnalyst'];
        }
    },
    watch: {
        localSidebar(newValue) {
            if (!newValue) {
                this.$emit('close-sidebar', newValue);
                this.leaveCurrentChannel()
                this.atendimentoLocal = {
                    id: "",
                    mensagens: [],
                    status: ""
                }
            }
        },
        sidebar(newValue) {
            this.localSidebar = newValue;
            if (this.localSidebar && this.atendimento.id) {
                this.getAtendimento();
            }
            if (!newValue) {
                this.leaveCurrentChannel();
            }
        },
        atendimentoLocal(newValue) {
            if (newValue && newValue.id && !this.channel) {
                this.initChannel();
            } else if (!newValue) {
                this.leaveCurrentChannel()
            }
        }
    },
    methods: {
        scrollToBottom() {
            const element = document.getElementById('card-msg');
            element.scrollTop = element.scrollHeight;

            // const chatContainer = document.getElementById('teste') // this.$refs.chatcontainer;
            // chatContainer.scrolltop = chatContainer.scrollHeight;
        },
        iniciarAtendimento() {
            const vm = this;
            vm.loading = true;
            axios.post('/atendimento/iniciar/' + this.atendimentoLocal.id)
                .then((response) => {
                    vm.atendimentoLocal = response.data.atendimento
                    vm.initChannel();
                    vm.$emit('search_services');
                    console.log('iniciar atendimento', response.data);
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    vm.loading = false;
                })
        },
        removeFile() {
            this.file = null
        },
        triggerFileInput() {
            this.$refs.fileInput.$el.querySelector('input').click();
        },
        handleFile(file) {
        },
        getAtendimento() {
            const vm = this;
            vm.loading = true;
            axios.get(`/atendimento/${this.atendimento.id}`)
                .then(response => {
                    vm.atendimentoLocal = response.data;
                    vm.$nextTick(() => { vm.scrollToBottom() })
                })
                .catch(error => {
                    console.error(error);
                }).finally(() => {
                    vm.loading = false;
                });
        },
        enviarMensagem() {
            const vm = this;
            if (!this.atendimentoLocal.id && (!this.titulo || this.titulo.length < 10 || this.titulo.length > 180)) {
                return vm.$swal({
                    title: "Atenção",
                    text: "Título deve ter entre 10 e 180 caracteres",
                    icon: "error",
                });
            }
            if (this.mensagem.length < 1 && !this.file) {
                return
            }
            if (this.file && !this.validarTamanho(this.file)) {
                return vm.$swal({
                    title: "Atenção",
                    text: "Tamanho de anexo excedido",
                    icon: "warning",
                    footer: "Tamanho máximo: 20mb"
                });
            }
            if (this.file && !this.validarExtensao(this.file)) {
                return vm.$swal({
                    title: "Atenção",
                    text: "Tipo de anexo inválido",
                    icon: "warning",
                    footer: "Formatos permitidos: jpg, jpeg, png, gif, pdf"
                });
            }
            let form = new FormData();
            form.append("mensagem", vm.mensagem);
            form.append("titulo", vm.titulo);
            form.append("status", vm.atendimentoLocal.status ?? 'NOVO');
            if (vm.atendimentoLocal && vm.atendimentoLocal.id) {
                form.append("id", vm.atendimentoLocal.id);
            }
            if (this.file) {
                form.append("anexo", this.file);
            }
            if (this.channel) {
                this.channel.listenForWhisper('stopTyping', (e) => {
                    this.chatUserTyping = false;
                });
            }
            vm.loading = true
            axios.post('/atendimento', form)
                .then((response) => {
                    if (!vm.atendimentoLocal.id) {
                        vm.atendimentoLocal = response.data.atendimento;
                        vm.$emit('search_services');
                    } else {
                        const findMessage = vm.atendimentoLocal.mensagens.find(e => e.id == response.data.mensagem.id)
                        if (!findMessage) {
                            vm.atendimentoLocal.mensagens.push(response.data.mensagem)
                        }
                    }
                    vm.$nextTick(() => { vm.scrollToBottom() })
                    vm.clearForm()
                })
                .catch(error => {
                    console.error(error);
                }).finally(() => {
                    vm.loading = false;
                });
        },
        clearForm() {
            this.titulo = '';
            this.mensagem = '';
            this.file = null;
        },
        validarTamanho(arquivo) {
            const tamanhoMaximoBytes = 22 * 1024 * 1024;
            return arquivo.size <= tamanhoMaximoBytes;
        },
        validarExtensao(arquivo) {
            const extensoesPermitidas = ["jpg", "jpeg", "png", "gif", "pdf"]
            const extensao = arquivo.name.split('.').pop().toLowerCase();
            return extensoesPermitidas.includes(extensao);
        },
        sendTyping() {
            if (this.channel && this.atendimentoLocal && this.atendimentoLocal.id) {
                if (this.typingTimer) {
                    clearTimeout(this.typingTimer);
                }
                this.channel.whisper('typing', { data: this.atendimentoLocal.id });
                this.typingTimer = setTimeout(() => {
                    this.channel.whisper('stopTyping', { data: this.atendimentoLocal.id })
                }, 1400);
            }
        },
        initChannel() {
            const vm = this;

            if (this.atendimentoLocal && this.atendimentoLocal.id) {
                initEcho();
                this.channel = Echo.private('chat.' + this.atendimentoLocal.id)
                    .listen('NewMessage', (message) => {
                        const findMessage = vm.atendimentoLocal.mensagens.find(e => e.id == message.message.id)
                        if (!findMessage) {
                            vm.atendimentoLocal.mensagens.push(message.message);
                        }
                        vm.$nextTick(() => { vm.scrollToBottom() })
                    })
                    .listenForWhisper('typing', (e) => {
                        console.log('digitando')
                        this.chatUserTyping = true;
                    })
                    .listenForWhisper('stopTyping', (e) => {
                        console.log('parou de digitar')
                        this.chatUserTyping = false;
                    });
                if (this.isDistribuidor) {
                    this.userResponse = {
                        id: this.atendimentoLocal
                    }
                }
            }
            vm.$nextTick(() => { vm.scrollToBottom() })

        },
        leaveCurrentChannel() {
            console.log('init channel', this.channel)
            if (this.channel) {
                console.log('Parando Channel')
                // Pare de escutar os eventos específicos para limpar listeners
                this.channel.stopListening('NewMessage');
                this.channel.stopListening('typing');
                this.channel.stopListening('stopTyping');

                // Deixe o canal no Echo
                Echo.leave(this.channel.name);
                this.channel = null; // Limpe a referência
            }
        },
    },
    mounted() {
        // console.log(this.profile)
        // const cookies = document.cookie.split('; ');
        // const cookie = cookies.find(row => row.startsWith('XSRF-TOKEN' + '='));
        // console.log('cookie', cookie);
    }

}

</script>

<style scoped>
.card-msgs {
    height: 93%;
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/atendimento/Sidebar.vue